<style scoped>
  .title{font-size: 16px;color: #00a2e9;display: inline-block;line-height: 66px;padding: 0 24px;}
  .title div{width: 4px;height: 18px;background-color: #00a2e9;display: inline-block;margin-right: 5px;vertical-align: text-bottom;}
  .time{display: inline-block;float: right;line-height: 66px;padding: 0 24px;}
  .member >>> .ivu-select-selection{border-radius: 18px;}
  .member >>> .ivu-btn{border-radius: 15px;width: 80px;height: 30px;margin-left: 6px;}
  .list-panel{background-color: white;padding:0 40px}
  .notice-background{background: url("/img/sys/bg4.png");height: 140px;}
  .project{text-align: center;font-size: 14px;color: #333333;height: 62px;border-bottom: 1px solid #d7dde4;line-height: 62px;background-color: #fff;}
</style>

<template>
  <div class="member">
    <Row style="margin-bottom:15px">
      <Col span="24" class="notice-background"></Col>
    </Row>
    <chart1></chart1>
    <Row>
      <Col span="24" style="margin-bottom: 40px;">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">知识贡献榜</p>
          </div>
          <div class="time">
            <Select v-model="model1" style="width:160px">
              <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
          <Col span="24" style="text-align: center;background-color: #fff;">
            <!--for-->
            <Col span="8" style="margin: 30px 0;" v-for="i in 3">
              <p style="color: #f64b4b;font-size: 24px;">26</p>
              <p style="color: #464c5b;font-size: 14px;">今日统计</p>
            </Col>
          </Col>
        </div>
      </Col>
    </Row>
    <!--年度创收达人榜-->
    <Row :gutter="40">
      <Col span="12" style="margin-bottom: 40px;">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">年度创收达人榜</p>
            <Button style="background-color: #00a2e9;color: #fff">导出表格</Button>
          </div>
          <div class="time">
            <Select v-model="model1" style="width:120px">
              <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Select v-model="model1" style="width:120px;margin-left: 12px;">
              <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
          <Col span="24" style="text-align: center;background-color: #fff;" class="list-panel">
            <div class=" project" style="font-weight: bold;">
              <Col span="6">排名</Col>
              <Col span="6">签约总额</Col>
              <Col span="6">办公地</Col>
              <Col span="6">律师</Col>
            </div>
            <!--for-->
            <div class=" project" v-for="i in 5" style="line-height: 95px;height: 95px;">
              <Col span="6">1</Col>
              <Col span="6">4200</Col>
              <Col span="6">海南</Col>
              <Col span="6">林志豪</Col>
            </div>
            <div style="padding: 20px"></div>
          </Col>
        </div>
      </Col>
      <!--年度办案能手榜-->
      <Col span="12" style="margin-bottom: 40px;">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">年度办案能手榜</p>
            <Button style="background-color: #00a2e9;color: #fff">导出表格</Button>
          </div>
          <div class="time">
            <Select v-model="model1" style="width:160px">
              <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
          <Col span="24" style="text-align: center;background-color: #fff;" class="list-panel">
            <div class=" project" style="font-weight: bold;">
              <Col span="6">排名</Col>
              <Col span="6">签约总额</Col>
              <Col span="6">办公地</Col>
              <Col span="6">律师</Col>
            </div>
            <!--for-->
            <div class=" project" v-for="i in 5" style="line-height: 95px;height: 95px;">
              <Col span="6">1</Col>
              <Col span="6">4200</Col>
              <Col span="6">海南</Col>
              <Col span="6">林志豪</Col>
            </div>
            <div style="padding: 20px"></div>
          </Col>
        </div>
      </Col>
    </Row>
    <!--全员表-->
    <Row>
      <Col span="24">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">全员表</p>
            <Button style="background-color: #00a2e9;color: #fff">导出表格</Button>
          </div>
        </div>
      </Col>
      <!---->
      <Col span="24" style="text-align: center;background-color: #fff;" class="list-panel">
        <div class=" project" style="font-weight: bold;">
          <Col span="2">学历</Col>
          <Col span="2">政治面貌</Col>
          <Col span="2">执业年限</Col>
          <Col span="3">经常办公地</Col>
          <Col span="2">工作语言</Col>
          <Col span="3">擅长领域</Col>
          <Col span="2">社会职务</Col>
          <Col span="3">主要荣耀</Col>
          <Col span="2">其他执业资格</Col>
          <Col span="3">联系方式</Col>
        </div>
        <!--for-->
        <div class=" project" v-for="i in 5" style="line-height: 95px;height: 95px;">
          <Col span="2">学历</Col>
          <Col span="2">政治面貌</Col>
          <Col span="2">执业年限</Col>
          <Col span="3">经常办公地</Col>
          <Col span="2">工作语言</Col>
          <Col span="3">擅长领域</Col>
          <Col span="2">社会职务</Col>
          <Col span="3">主要荣耀</Col>
          <Col span="2">其他执业资格</Col>
          <Col span="3">联系方式</Col>
        </div>
        <Col span="24" style="margin:40px 0 57px 0;text-align: left;">
            <Page :total="100" show-elevator />
        </Col>
      </Col>
    </Row>
  </div>
</template>

<script>
  import chart1 from '../../components/data/chart1'
  export default {
    name: "member",//成员统计
    components: {chart1:chart1,},
  }
</script>

